const breakPoint = 699;
let columnSplide;
let isColumnSplide;
let columnSlides;
window.addEventListener("DOMContentLoaded", () => {
  columnSlides = document.querySelectorAll(".columnSplide .splide__slide");
  if (breakPoint < window.innerWidth) {
    isColumnSplide = false;
  } else {
    createColumnSplide();
    isColumnSplide = true;
  }
});
function resize(func) {
  let timeoutId;
  window.addEventListener(
    "resize",
    function () {
      // setTimeout()がセットされていたら無視
      if (timeoutId) return;

      timeoutId = setTimeout(function () {
        timeoutId = 0;

        // 処理内容
        func();
      }, 500);
    },
    false
  );
}

function resizeFunc() {
  // pc以上でかつspからpcに変わったとき
  if (breakPoint < window.innerWidth && isColumnSplide) {
    isColumnSplide = false;
    // themeの[reveal-on-scroll="true"]でopacity=0にされてしまうので1にする
    document.querySelector('.c-blog-posts .blog-post-list').style.opacity = 1;

  } else if (breakPoint >= window.innerWidth && !isColumnSplide) {
    createColumnSplide();
    isColumnSplide = true;
  }
}
resize(resizeFunc);

const createColumnSplide = () => {
  if (columnSlides.length > 1) {
    columnSplide = new Splide(".splide.columnSplide", {
      autoplay: true,
      // type: "loop",
      // fixedWidth: "77.34%",
      fixedWidth: "87.08%",
      padding: {left: 22, right: 20},
      pauseOnHover: false,
      pauseOnFocus: false,
      interval: 7000,
      speed: 1500,
      destroy: "completely",
      breakpoints: {
        700: {
          destroy: false, // 700px未満でスライダー開始
        },
      },
    });
    // スライドの移動が始まったときに矢印からdisabledを外す
    columnSplide.on("move", function () {
      const arrows = columnSplide.root.querySelectorAll(".splide__arrow");
      arrows.forEach(function (arrow) {
        // `disabled` を外す
        if(arrow.hasAttribute("disabled"))
        arrow.removeAttribute("disabled");
      });
    });
    columnSplide.on("pagination:mounted", function (data) {
      data.list.classList.add("splide__pagination-item");

      // `items`は、すべてのLI要素とボタン要素を保持しています
      data.items.forEach(function (item) {
        item.button.innerHTML = `<svg width="7" height="7" viewBox="0 0 7 7" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_1364_2262)">
<path d="M6.38826 1.47727C6.07431 0.851973 5.53212 0.495335 4.92565 0.238025C4.01455 -0.149831 3.13325 -0.0855034 2.36561 0.585204C1.50202 1.33821 0.970078 2.30596 0.832201 3.4525C0.698051 4.5735 1.23558 5.44097 2.2324 5.84302C2.66652 6.01803 3.12114 6.09938 3.64004 6.10411C4.07696 6.12587 4.51947 5.98303 4.92193 5.70964C5.72869 5.16002 6.21964 4.38241 6.4777 3.44588C6.66029 2.78274 6.7106 2.12055 6.38826 1.47727ZM5.45201 4.20551C5.37841 4.50066 5.17998 4.65202 4.81479 4.63972C4.62474 4.62364 4.40116 4.51012 4.17758 4.40606C3.54968 4.1147 2.96277 3.75143 2.42803 3.30871C2.09638 3.03343 1.97062 2.66449 2.03862 2.23596C2.08241 1.96351 2.18768 1.70999 2.31345 1.46498C2.36655 1.36092 2.42058 1.32875 2.53051 1.39213C3.31119 1.8377 4.12448 2.22461 4.86976 2.73449C5.275 3.01167 5.56566 3.74954 5.45294 4.20646L5.45201 4.20551Z" class="icon-line"/>
</g>
<defs>
<clipPath id="clip0_1364_2262">
<rect width="5.81132" height="6.10732" fill="white" transform="translate(0.811279)"/>
</clipPath>
</defs>
</svg>
`;
      });
    });
    columnSplide.mount();
  }
};
